import { useEffect, useState } from "react";
import postcss from 'postcss';
import nested from 'postcss-nested';

import { VirtualStyleBuilder } from "./virtual/VirtualStyleBuilder";
import { Article } from "@/constants";

const cssProcessor = postcss([nested()]);

/*
    React hook that creates a css style for all the articles
*/
export function useArticleStyle(
    article: Article,
    styles: Map<string, any>,
): UseStlyleResponse {
    const [css, setCss] = useState('');
    const [classNameMap, setClassNameMap] = useState<Map<string, string>>(
        new Map(),
    );
    useEffect(() => {
        if (!styles.size) {
            setCss(' ');
            return;
        }
        const builder = new VirtualStyleBuilder([article], styles);
        builder
            .build()
            .then(({ css, classNameMap }) => {
                setClassNameMap(classNameMap);
                return compileCSS(css);
            })
            .then(result => {
                console.log(`Sass compilation success`);
                setCss(result);
            })
            .catch(e => {
                console.log(`Error processing styles`, e);
                setCss('');
            });
    }, [article, styles]);
    return {
        css,
        classNameMap,
    };
}

interface UseStlyleResponse {
    css: string;
    classNameMap: Map<string, string>;
}

/**
 * Compile CSS string using PostCSS with nested plugin
 * Replaces the Sass compileStringAsync functionality
 */
async function compileCSS(cssString: string): Promise<string> {
    const result = await cssProcessor.process(cssString, {
        from: undefined,
        // Add source map if needed in development
        map: false,
    });

    return result.css;
}